import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import './Footer.css';
import adritemLogo from '../../assets/icons/adritem.png';
import govPTLogo from '../../assets/icons/govPT.png';
import ueLogo from '../../assets/icons/ue.png';
import leaderLogo from '../../assets/icons/leader.png';
import proderLogo from '../../assets/icons/proder.png';
import iconReclamacao from '../../assets/IconReclamacao.png';


const Footer = () => {
    const { language } = useLanguage();
    const t = translations?.[language] || translations?.pt || {};
    return (
        <div className="footer">
            <div className="footer-line"></div>
            <div className="footer-content">
                <div className="footer-icons">
                    <a
                        href="https://www.gohotels.com/en/a/tapada-de-s-domingos.htm"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="award-box-link"
                    >
                        <div className="award-box">
                            <div className="award-content">
                                <span className="award-title">Outstanding Service</span>
                                <span className="award-year">Award 2017</span>
                            </div>
                            <div className="award-presented">
                                <span>Presented by Gohotels.com</span>
                            </div>
                        </div>
                    </a>
                    <a href="https://www.adritem.pt" target="_blank" rel="noopener noreferrer">
                        <img src={adritemLogo} alt="ADRITEM" className="footer-icon" />
                    </a>
                    <a href="https://www.portugal2020.pt" target="_blank" rel="noopener noreferrer">
                        <img src={govPTLogo} alt="Portugal 2020" className="footer-icon" />
                    </a>

                    <a href="https://http://proder.pt/" target="_blank" rel="noopener noreferrer">
                        <img src={proderLogo} alt="proder" className="footer-icon" />
                    </a>
                    <img src={leaderLogo} alt="leader" className="footer-icon" />

                    <a href="https://europa.eu" target="_blank" rel="noopener noreferrer">
                        <img src={ueLogo} alt="European Union" className="footer-icon" />
                    </a>
                    <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" rel="noopener noreferrer">
                        <img src={iconReclamacao} alt="Livro de Reclamações" className="footer-icon footer-icon-reclamacao" />
                    </a>
                </div>
                <div className="footer-copyright">
                    {t.footer.copyright}
                </div>
            </div>
        </div>
    );
};

export default Footer;